import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BankingCustomer } from '../banking.model';
import { AppPageService, SyncedBankAccount } from 'common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-banking-customer-app-bar-title',
    templateUrl: './banking-customer-app-bar-title.component.html',
    styleUrls: ['./banking-customer-app-bar-title.component.scss'],
    standalone: false
})
export class BankingCustomerAppBarTitleComponent implements OnInit {

  title: string;
  bankAccountName: string;

  constructor(private route: ActivatedRoute,
    private appPageService: AppPageService,
    private router: Router) { }

  backToBankCustomerList() {
    this.router.navigate([`/banking`]);
  }

  backToBankCustomerBankAccountList() {
    this.appPageService.back();
  }

  data: BankCustomerAppBarTitleComponentData;

  dataSet(data: BankCustomerAppBarTitleComponentData) {
    this.data = data;
    this.title = data.bankingCustomer ? `${data.bankingCustomer.name || ''}` : '';
    this.bankAccountName = data.bankingAccount
      ? `${data.bankingAccount.institutionName + ' -' || ''} ${data.bankingAccount.name || ''}` : '';
  }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe(this.dataSet.bind(this));
  }

}

export interface BankCustomerAppBarTitleComponentData {
  bankingAccount?: SyncedBankAccount;
  bankingCustomer?: BankingCustomer;
}
